import { IntlShape } from 'react-intl';
import type { CascadingOption } from '@/components/mui/Form/Select/SelectCascading/types';

type FormatMessage = IntlShape['formatMessage'];

export type PeriodValue = {
  value: number | null;
  type: 'month' | 'year';
};

export type TopVendorValue = number;

export const createPeriodOptions = (formatMessage: FormatMessage): CascadingOption[] => {
  const currentYear = new Date().getFullYear();

  return [
    {
      label: formatMessage(
        {
          id: 'options.vendorExpenses.period.lastMonths',
          defaultMessage: 'Last 3 months',
        },
        {
          period: 3,
        },
      ),
      value: {
        value: 3,
        type: 'month',
      },
    },
    {
      label: formatMessage(
        {
          id: 'options.vendorExpenses.period.lastMonths',
          defaultMessage: 'Last 6 months',
        },
        {
          period: 6,
        },
      ),
      value: {
        value: 6,
        type: 'month',
      },
    },
    {
      label: formatMessage(
        {
          id: 'options.vendorExpenses.period.lastMonths',
          defaultMessage: 'Last 12 months',
        },
        {
          period: 12,
        },
      ),
      value: {
        value: 12,
        type: 'month',
      },
    },
    {
      label: formatMessage({
        id: 'options.vendorExpenses.period.byYear',
        defaultMessage: 'By year',
      }),
      value: {
        value: null,
        type: 'year',
      },
      // Generate yearly options from 2022 to current year
      submenu: Array.from({ length: currentYear - 2021 }, (_, i) => 2022 + i).map((year) => ({
        label: year,
        value: {
          value: year,
          type: 'year',
        },
      })),
    },
  ];
};

export const createTopVendorOptions = (formatMessage: FormatMessage): CascadingOption[] => [
  {
    label: formatMessage(
      {
        id: 'options.vendorExpenses.topVendors',
        defaultMessage: 'Top 10 vendors by spend',
      },
      {
        value: 10,
      },
    ),
    value: 10,
  },
  {
    label: formatMessage(
      {
        id: 'options.vendorExpenses.topVendors',
        defaultMessage: 'Top 50 vendors by spend',
      },
      {
        value: 50,
      },
    ),
    value: 50,
  },
  {
    label: formatMessage(
      {
        id: 'options.vendorExpenses.topVendors',
        defaultMessage: 'Top 100 vendors by spend',
      },
      {
        value: 100,
      },
    ),
    value: 100,
  },
];
